import { http } from "@/http";

export default {
  save(payload) {
    return http.post("/api/v1/admin/asset", payload);
  }
};
